import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(() => ({
  pdfWrapper: (props) => ({
    width: props.isOnMediaPage ? '90%' : '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    overflow: 'auto',
    position: 'relative',
    height: '100%',
  }),
  controlPanel: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    width: '100%', // Make sure control panel takes full width
    backgroundColor: '#232323',
  },
  pdfDocument: () => ({
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),

  pdfPage: (props) => ({
    '@media (max-width: 1600px)': {
      width: props.isOnMediaPage ? '75%' : '100%',
    },
    height: 'auto',
    backgroundColor: 'transparent',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 'auto',
  }),
  '@media (max-width: 1600px)': {
    pdfWrapper: (props) => ({
      width: props.isOnMediaPage ? 'calc(100% + 10px)' : 'calc(100% - 50px)',
      display: 'flex',
      justifyContent: 'center',
      '@media (max-width: 1600px)': {
        width: props.isOnMediaPage ? 'calc(60% + 250px)' : 'calc(100% - 50px)',
      },
    }),
  },
  reactPdfPageTextContent: {
    display: 'none',
  },
}));
